export const IMPORT_SOURCES = {
  IMMOPEN: 'immopen',
  NEOTEEM: 'neoteem',
  RNIC_EXCEL: 'rnic-excel',
  SCI_EXCEL: 'sci-excel',
} as const;

export type ImportSource = typeof IMPORT_SOURCES[keyof typeof IMPORT_SOURCES];

type ImportSourceBadgeMode = 'success' | 'warning' | 'error' | 'info';

type ImportSourceConfig = {
  label: string;
  badgeMode: ImportSourceBadgeMode;
};

const IMPORT_SOURCE_CONFIGS: Record<ImportSource, ImportSourceConfig> = {
  [IMPORT_SOURCES.NEOTEEM]: {
    label: 'Neoteem',
    badgeMode: 'success',
  },
  [IMPORT_SOURCES.IMMOPEN]: {
    label: 'ImmOpen',
    badgeMode: 'info',
  },
  [IMPORT_SOURCES.RNIC_EXCEL]: {
    label: 'RNIC Excel',
    badgeMode: 'info',
  },
  [IMPORT_SOURCES.SCI_EXCEL]: {
    label: 'Contacts SCI',
    badgeMode: 'warning',
  },
};

export const IMPORT_SOURCE_OPTIONS: Array<{ value: ImportSource; label: string }> = [
  { value: IMPORT_SOURCES.NEOTEEM, label: IMPORT_SOURCE_CONFIGS[IMPORT_SOURCES.NEOTEEM].label },
  { value: IMPORT_SOURCES.IMMOPEN, label: IMPORT_SOURCE_CONFIGS[IMPORT_SOURCES.IMMOPEN].label },
  { value: IMPORT_SOURCES.RNIC_EXCEL, label: IMPORT_SOURCE_CONFIGS[IMPORT_SOURCES.RNIC_EXCEL].label },
  { value: IMPORT_SOURCES.SCI_EXCEL, label: IMPORT_SOURCE_CONFIGS[IMPORT_SOURCES.SCI_EXCEL].label },
];

export const getImportSourceLabel = (source: string | null): string => {
  if (!source) {
    return 'Non spécifié';
  }

  const typedSource = source as ImportSource;
  return IMPORT_SOURCE_CONFIGS[typedSource]?.label ?? source;
};

export const getImportSourceBadgeMode = (source: string | null): ImportSourceBadgeMode => {
  if (!source) {
    return 'warning';
  }

  const typedSource = source as ImportSource;
  return IMPORT_SOURCE_CONFIGS[typedSource]?.badgeMode ?? 'warning';
};
